import { useInfiniteHits } from 'react-instantsearch';
import { useRef, useEffect } from 'react';
import twitterIcon from '../../assets/icons/twitter-x.svg';
import detailsIcon from '../../assets/icons/details.jpg';
import { DataGrid } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';

export default function AthleteSummary(props) {
    const { hits: currentPageHits } = useInfiniteHits(props);
    const { role } = props;
    const gridWrapperRef = useRef(null);

    useEffect(() => {
        const wrapper = gridWrapperRef.current;
        if (!wrapper) return;
        const virtualScroller = wrapper.querySelector('.MuiDataGrid-virtualScroller');
        const topScrollBar = wrapper.querySelector('.top-scrollbar');
        const topScrollInner = wrapper.querySelector('.top-scrollbar-inner');
        if (!virtualScroller || !topScrollBar || !topScrollInner) return;
        topScrollInner.style.width = virtualScroller.scrollWidth + 'px';
        const syncFromTop = () => { virtualScroller.scrollLeft = topScrollBar.scrollLeft; };
        const syncFromBottom = () => { topScrollBar.scrollLeft = virtualScroller.scrollLeft; };
        topScrollBar.addEventListener('scroll', syncFromTop);
        virtualScroller.addEventListener('scroll', syncFromBottom);
        return () => {
            topScrollBar.removeEventListener('scroll', syncFromTop);
            virtualScroller.removeEventListener('scroll', syncFromBottom);
        };
    }, [currentPageHits]);
    
    function getRowId(row) {
        return row.objectID;
    }

    const columns = [
        { field: 'interactionType', headerName: 'TYPE', sortable: false, filterable: false, width: 100 },
        {
            field: 'profile',
            headerName: 'LINK',
            width: 75,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <a
                        style={{ color: 'green', textAlign: 'center' }}
                        href={`/recruit/view/${params.row.recruitId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img style={{ width: '25px' }} src={detailsIcon} alt="details" />
                    </a>
                </div>
            ),
        },
        { field: 'name', headerName: 'NAME', sortable: false, filterable: false, width: 250 },
        { field: 'year', headerName: 'YEAR', width: 80, sortable: false, filterable: false },
        { field: 'rank', headerName: 'NP RATING', sortable: false, filterable: false, width: 200 },
        { field: 'highSchool', headerName: 'HIGH SCHOOL', sortable: false, filterable: false, width: 300 },
        { field: 'location', headerName: 'ST', sortable: false, filterable: false, width: 50 },
        { field: 'hsCounty', headerName: 'COUNTY', sortable: false, filterable: false, width: 200 },
        { field: 'team', headerName: 'TEAM', sortable: false, filterable: false, width: 250 },
        { field: 'height', headerName: 'HT', sortable: false, filterable: false, width: 75 },
        { field: 'weight', headerName: 'WT', sortable: false, filterable: false, width: 50 },
        { field: 'offPosition', headerName: 'O', sortable: false, filterable: false, width: 100 },
        { field: 'defPosition', headerName: 'D', sortable: false, filterable: false, width: 100 },
        { field: 'specialTeamsPosition', headerName: 'ST', sortable: false, filterable: false, width: 100 },
        { field: 'scoutPos', headerName: 'SCOUT', sortable: false, filterable: false, width: 100 },
        { field: 'gpa', headerName: 'GPA', sortable: false, filterable: false, width: 50 },
        {
            field: 'twitter',
            headerName: 'TWITTER',
            width: 75,
            sortable: false, 
            filterable: false,
            renderCell: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip title={params.row.detail}>
                    <a
                        style={{ color: 'green', textAlign: 'center' }}
                        href={`https://x.com/${params.row.twitter}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img style={{ width: '15px' }} src={twitterIcon} alt="twitter" />
                    </a>
                    </Tooltip>
                </div>
            ),
        },
        
    ];

    if (role && role.User_Role?.type === 'A') {
        columns.push({
            field: 'recruitId',
            headerName: 'Edit',
            sortable: false,
            filterable: false,
            width: 75,
            renderCell: (params) => (
                <a href={`/admin/athlete/${params.value}`} target="_blank" rel="noopener noreferrer">
                    Edit
                </a>
            ),
        });
    }

    return (
        <div>
            {currentPageHits && currentPageHits.length > 0 ? (
                <div ref={gridWrapperRef}>
                    <div className="top-scrollbar" style={{ overflowX: 'auto', overflowY: 'hidden', height: '15px' }}>
                        <div className="top-scrollbar-inner" style={{ height: '1px' }} />
                    </div>
                    <DataGrid
                        sx={{
                            '& .MuiDataGrid-cell': {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                color: 'white',
                                backgroundColor: '#026534',
                                fontWeight: 'bold',
                            },
                            '& .MuiDataGrid-columnHeaderRow': {
                                backgroundColor: '#026534',
                            },
                            '& .MuiDataGrid-filler': {
                                backgroundColor: '#026534',
                            },
                        }}
                        rows={currentPageHits}
                        density={"comfortable"}
                        rowHeight={45}
                        columns={columns}
                        pageSize={25}
                        rowsPerPageOptions={[25, 50, 100]}
                        pagination
                        getRowId={getRowId} // Pass the function reference
                    />
                </div>
            ) : null}
        </div>
    );
}
